<!--
  One media thumbnail. Resolves its URL through mediaApi (uploaded files live in IndexedDB while the
  prototype is mocked), and marks videos, counts and who can see it.
-->
<template>
  <div class="md-thumb" :style="{ aspectRatio: ratio }">
    <img v-if="url" :src="url" :alt="alt" loading="lazy" draggable="false" />
    <div v-else class="md-thumb-empty">{{ item && item.kind === 'video' ? '▶' : '…' }}</div>
    <span v-if="item && item.kind === 'video' && count <= 1" class="md-thumb-badge">▶ {{ duration }}</span>
    <span v-if="count > 1" class="md-thumb-count">{{ count }} {{ countLabel }}</span>
    <span v-if="showVisibility && item" class="md-thumb-vis" :title="item.patient_visible ? 'Patient can see this' : 'Staff only'">
      {{ item.patient_visible ? '👁' : '🔒' }}
    </span>
  </div>
</template>

<script setup>
import { ref, computed, watch } from 'vue';
import { getMediaUrl } from '@/api/mediaApi';

const props = defineProps({
  item: { type: Object, default: null },
  count: { type: Number, default: 0 },
  countLabel: { type: String, default: 'items' },
  ratio: { type: String, default: '4 / 3' },
  showVisibility: { type: Boolean, default: false },
});

const url = ref(null);
const alt = computed(() => (props.item && props.item.note) || 'Patient media');
const duration = computed(() => {
  const s = Math.round((props.item && props.item.duration_sec) || 0);
  return s ? `${Math.floor(s / 60)}:${String(s % 60).padStart(2, '0')}` : '';
});

watch(() => props.item && props.item.public_id, async () => {
  url.value = props.item ? await getMediaUrl(props.item, 'thumb') : null;
}, { immediate: true });
</script>

<style scoped>
.md-thumb { position:relative; width:100%; background:#2b3a40; overflow:hidden; }
.md-thumb img { width:100%; height:100%; object-fit:cover; display:block; }
.md-thumb-empty { position:absolute; inset:0; display:flex; align-items:center; justify-content:center; color:#cfd8da; font-size:28px; }
.md-thumb-badge, .md-thumb-count, .md-thumb-vis { position:absolute; background:rgba(0,0,0,.65); color:#fff; font-size:12px; border-radius:5px; padding:1px 7px; }
.md-thumb-badge { right:6px; bottom:6px; }
.md-thumb-count { left:6px; bottom:6px; }
.md-thumb-vis { right:6px; top:6px; padding:0 5px; }
</style>
